import React, { useEffect, useState } from "react";
import "./createPostFirst.css";
import Form from "react-bootstrap/Form";
import axios from "../../../axios";
// import Select from "react-select";
import Select, { components } from "react-select";
import { createFilter } from "react-select";
import { IP } from "../../../internalServer";
import { useSelector } from "react-redux";
import moment from "moment";
import assets from "../../../assets/assets";
import CreatableSelect from "react-select/creatable";
import { FormControl, InputLabel, MenuItem, NativeSelect, OutlinedInput, TextField } from "@mui/material";
import { useLocation } from "react-router-dom";

const CreatePostFirst = ({
  editingMode,
  clickPost,
  setClickPost,
  post,
  isInsideOfCommunity,
  communityData,
  setIsPostCreated,
  setAllPost,
  setPostCreatedCount,
  setChoosedCommunity,
  getPostRequest,
}) => {
  const [filter, setFilter] = useState({
    page: 1
  });
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [postTopicList, setPostTopicList] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [postAttach, setPostAttach] = useState([]);
  const [editingPostImages, setEditingPostImages] = useState(post?.post_image);
  const [communities, setCommunities] = useState([]);
  const [isInProgress, setIsInProgress] = useState(false);
  const [tagLimit, setTagLimit] = useState(false);
  const navigate = useLocation()
  const [selectedCommunity, setSelectedCommunity] = useState({
    communityName: communityData
      ? communityData?.community_name
      : post?.community_id?.community_name
        ? post?.community_id?.community_name
        : null,
    communityProfilePicture: communityData
      ? communityData?.profile_picture
      : post?.community_id?.community_name
        ? post?.community_id?.profile_picture
        : null,
  });
  const { communityName, communityProfilePicture } = selectedCommunity;
  // const [selectedOptions, setSelectedOptions] = useState([]);

  const [postForm, setPostForm] = useState({
    title: "xploreSense",
    description: post?.description ? post?.description : null,
    community: post?.community_id?.id
      ? post?.community_id?.id
      : communityData?.id
        ? communityData?.id
        : null,
    topic: post?.tags ? post?.tags : [],
  });

  const { title, description, community, topic } = postForm;

  useEffect(() => {
    const getCommuntiy = async () => {
      await axios
        .get(`/community/getByUserId/student/${currentUser?.id}`)
        .then((response) => {
          setCommunities(response.data.data);
        });

      await axios
        .get(`/community/post/topic/getByUserId/student/${currentUser?.id}`)
        .then((response) => {
          const topicList = response.data.data.map((item, index) => {
            return {
              id: index,
              label: item.topic,
              value: item.topic,
            };
          });

          setPostTopicList(topicList);
        });
    };
    getCommuntiy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const imageHandler = (e) => {
    let totalSize = postAttach.reduce((acc, file) => acc + file.size, 0);
    for (const file of e.target.files) {
      if (totalSize + file.size <= 10 * 1024 * 1024 && validateFileType(file)) {
        if (postAttach.length < 5) {
          setPostAttach((prev) => [...prev, file]);
          totalSize += file.size;
        }
      } else {
        setIsValidFileType(false);
        return;
      }
    }
    e.target.value = '';
  };

  const handlePostSubmit = async (e) => {
    e.preventDefault();
    setIsInProgress(true);
    let newPost = {
      user_id: currentUser?.id,
      title,
      description,
      tags: topic,
      status: "pending"
    };

    if (postAttach) {
      let attachments = [];
      for (const post of postAttach) {
        const formData = new FormData();
        formData.append("name", post.name);
        formData.append("uploadPostAttachment", post);
        try {
          const res = await axios.post(
            `/community/post/uploadAttachment/userId/${currentUser?.id}`,
            formData
          );
          // newPost.post_image = [res.data.data];
          attachments.push(res.data.data);
        } catch (error) {
          console.log(error);
        }
      }
      if (attachments.length > 0) {
        newPost.post_image = attachments;
      }
    }

    try {
      const res = await axios.post(
        `/community/${community}/post/create`,
        newPost
      );
      if (res) {
        setClickPost(false);
        setAllPost && setAllPost([]);
        setIsPostCreated((prev) => !prev);
        if (editingMode) {
          getPostRequest()
        }
        window.location.reload()
      }
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    }
    setFilter((filter) => {
      return {
        ...filter,
        page: 1
      }
    });
  };

  const handlePostUpdate = async (e) => {
    e.preventDefault();
    setIsInProgress(true);
    let newPost = {
      user_id: currentUser?.id,
      title,
      description,
      tags: topic,
      status: "pending"
    };

    if (postAttach) {
      let attachments = [];
      editingPostImages.forEach((image) => attachments.push(image));
      for (const post of postAttach) {
        const formData = new FormData();
        formData.append("name", post.name);
        formData.append("uploadPostAttachment", post);
        try {
          const res = await axios.post(
            `/community/post/uploadAttachment/userId/${currentUser?.id}`,
            formData
          );
          // newPost.post_image = [res.data.data];
          attachments.push(res.data.data);
        } catch (error) {
          console.log(error);
        }
      }
      if (attachments.length > 0) {
        newPost.post_image = attachments;
      }
    }

    try {
      const res = await axios.put(
        `/community/${post?.community_id?.id}/post/update/${post?.id}`,
        newPost
      );

      res && window.location.reload();
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
    } finally {
      setClickPost(false)
    }
  };

  const handleInputChange = (inputValue) => {
    if (inputValue.length > 20) {
      inputValue = inputValue.substring(0, 20);
      setTagLimit(true);
    } else {
      setTagLimit(false)
    }
    inputValue.length < 50 &&
      setPostTopicList((prev) => [
        ...prev,
        { value: inputValue, label: inputValue },
      ]);
  };

  const validateFileType = (filePath) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
    if (
      !allowedExtensions.exec(filePath.name) ||
      filePath.size > 10 * 1024 * 1024
    ) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time
    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();
    const outputDateString = `${day}-${month}-${year}`;
    return outputDateString;
  };
  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setPostForm({ ...postForm, topic: selectedValues });
  };


  return (
    <>
      {clickPost && (
        <div className="create_post_transprant_body">
          <div className=" p-4 create_post_container">
            <img
              src="/images/cross-circle3.svg"
              className="create_post_close_btn"
              alt=""
              onClick={(e) => setClickPost(false)}
            />
            <div className=" d-flex justify-content-between create_post_header_container">
              {editingMode ? (
                <div className="d-flex flex-column">
                  <span className=" create_post_header">Edit Post</span>
                  <span className="last_updated_post">
                    Last updated on {moment(post?.updated_at).format("DD-MM-YYYY")}
                  </span>
                </div>
              ) : (
                <div className=" create_post_header mb-3">Create New Post</div>
              )}
              {(communityProfilePicture || communityName) && (
                <div className="flex items-center gap-2">
                  <img
                    className="post_community_profile"
                    src={`${communityProfilePicture
                      ? `${IP}${communityProfilePicture}`
                      : assets?.CommunityImg
                      }`}
                    alt=""
                    onError={(e) => {
                      e.target.src = assets?.CommunityImg
                    }}
                  />
                  <span className="post_school_name">
                    &nbsp;{communityName}
                  </span>
                </div>
              )}
            </div>
            {!isInsideOfCommunity && !editingMode ? (
              <FormControl fullWidth>
                <InputLabel variant="outlined" htmlFor="uncontrolled-native">
                  Select Channel
                </InputLabel>
                <NativeSelect
                  defaultValue={""}
                  input={
                    <OutlinedInput
                      label="Select Channel"
                      id="uncontrolled-native"
                      sx={{
                        height: '48px',
                        boxSizing: 'border-box',
                      }}
                    />
                  }
                  onChange={(e) => {
                    setChoosedCommunity(e.target.value);
                    setPostForm({ ...postForm, community: e.target.value });
                    setSelectedCommunity({
                      communityName:
                        e.target.options[e.target.selectedIndex].getAttribute(
                          "community-name"
                        ),
                      communityProfilePicture: e.target.options[
                        e.target.selectedIndex
                      ].getAttribute("community-profile-picture"),
                    });
                  }}
                >
                  <option></option>
                  {communities &&
                    communities?.length > 0 &&
                    communities?.map((community, index) => (
                      <option
                        key={index}
                        value={community.id}
                        community-name={community.community_name}
                        community-profile-picture={community.profile_picture}
                        className="px-1"
                      >
                        {community.community_name}
                      </option>
                    ))}
                </NativeSelect>
              </FormControl>

              // <Form.Select
              //   onChange={(e) => {
              //     setChoosedCommunity(e.target.value);
              //     setPostForm({...postForm, community: e.target.value });
              //     setSelectedCommunity({
              //       communityName:
              //         e.target.options[e.target.selectedIndex].getAttribute(
              //           "community-name"
              //         ),
              //       communityProfilePicture: e.target.options[
              //         e.target.selectedIndex
              //       ].getAttribute("community-profile-picture"),
              //     });
              //   }}
              //   className=" mt-4 dropdownPlaceholder"
              //   style={{ borderColor: "#99ADBB" }}
              // >
              //   <option>Select Channel</option>
              //   {communities &&
              //     communities?.length > 0 &&
              //     communities?.map((community, index) => (
              //       <option
              //         key={index}
              //         value={community.id}
              //         community-name={community.community_name}
              //         community-profile-picture={community.profile_picture}
              //       >
              //         {community.community_name}
              //       </option>
              //     ))}
              // </Form.Select>
            ) : (
              <div className="slected_community_name mt-4">
                {
                  editingMode ? (
                    <span>{post?.community_id?.community_name}</span>
                  ) : (
                    <span>{communityData?.community_name}</span>
                  )}
              </div>
            )}
            <div>
              <div className="mt-4 addTopic">
                <CreatableSelect
                  placeholder="Add Tags...."
                  options={postForm.topic.length >= 3 ? [] : postTopicList}
                  isMulti
                  value={postForm.topic.map((topic) => ({
                    value: topic,
                    label: topic,
                  }))}
                  onChange={handleChange}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      padding: '3px 6px', // top-bottom, left-right padding
                      minHeight: 'auto',   // prevent default height override
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: '0 4px', // padding between tags and edge
                    }),
                  }}
                />
              </div>
              {/* <p className="tagsStyl">*Maximum 3 topics allowed.</p> */}
            </div>
            {/* <textarea
              type="text"
              placeholder="Description text"
              className="w-100  mt-3 post_text_field "
              value={description}
              maxLength={250}
              onChange={(e) =>
                setPostForm({ ...postForm, description: e.target.value })
              }
            /> */}
            <TextField
              id="outlined-multiline-flexible"
              label="Description"
              value={description}
              className="w-100 mt-3 z-0"
              multiline
              maxRows={4}
              onChange={(e) =>
                setPostForm({ ...postForm, description: e.target.value })
              }
              inputProps={{ maxLength: 250 }}
            />
            <div className="orange-scrollBar file_attach_container  d-flex align-items-center">
              {postAttach?.length > 0 &&
                postAttach.map((post, index) => (
                  <div key={index} className=" col-7 m-3  p-0 post_image_box1">
                    <img
                      src={URL.createObjectURL(post)}
                      className="post_image1"
                      alt=""
                      onError={(e) => {
                        e.target.src = assets?.CommunityImg
                      }}
                    />
                    <img
                      src={assets.CrossIcon}
                      className="w-7 post_image_close_btn"
                      alt=""
                      onClick={() =>
                        setPostAttach((prev) =>
                          prev.filter((_, i) => i !== index)
                        )
                      }
                    />
                  </div>
                ))}
              {editingPostImages &&
                editingPostImages.length > 0 &&
                editingPostImages.map((image, index) => (
                  <div key={index} className="col-7 m-3  p-0 post_image_box1">
                    <img
                      src={`${IP + image}`}
                      className="post_image1"
                      alt=""
                    />

                    <img
                      src={assets.CrossIcon}
                      className="post_image_close_btn w-6"
                      alt=""
                      onClick={() => {
                        setEditingPostImages(
                          editingPostImages.filter((item, i) => i !== index)
                        );
                        const inputFile = document.getElementById('attachFile');
                        if (inputFile) {
                          inputFile.value = ''; // This resets the file input
                        }
                      }}
                    />
                  </div>
                ))}
            </div>
            {tagLimit && (
              <p className="SpclStyle">Tag length exceeded, please enter a tag less than 20 Characters.</p>
            )}
            <div className="create_post_footer mt-3  d-flex align-items-center justify-content-between">
              <div className=" attach_section">
                <input
                  type="file"
                  id="attachFile"
                  accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx"
                  multiple
                  style={{ display: "none" }}
                  onChange={imageHandler}
                />
                <label
                  className="gap-2 d-flex align-items-center"
                  htmlFor="attachFile"
                >
                  <img
                    className="w-8"
                    src={assets.UploadIcon}
                    alt="icon"
                  />
                </label>
              </div>
              {editingMode ? (
                <button
                  onClick={handlePostUpdate}
                  disabled={
                    !description ||
                    !community ||
                    isInProgress
                  }
                  className="  btn btn-danger px-4  post_btn1"
                >
                  Update
                </button>
              ) : (
                <button
                  onClick={handlePostSubmit}
                  disabled={
                    !description ||
                    !community
                  }
                  className="  btn btn-danger px-4  post_btn1"
                >
                  Post
                </button>
              )}
            </div>
            {!isValidFileType && (
              <p id="errorMsg">
                "Exceeded Limit !!
                Max 5 attachments and total of 10 MB size is allowed."
              </p>
            )}
          </div >
        </div >
      )}
    </>
  );
};

export default CreatePostFirst;
